import Modal from "components/Elements/Modalv2";
import NameGroup from "pages/GroupTable/NameGroup";
import React, { FC } from "react";

interface NameGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const NameGroupModal: FC<NameGroupModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <NameGroup />
    </Modal>
  );
};

export default NameGroupModal;
